import React from 'react';
import { Container } from 'reactstrap';
import ProductiveCyclesList from './ProductiveCyclesList';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import UiContent from '../../Components/Common/UiContent';
import { icon } from 'leaflet';


//redux

const ProductiveCycles = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Producción', icon: 'icon-bubbles' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Ciclo Productivo' links={breadcrumbLinks} icon={'icon-circle-dashed'} />
					<ProductiveCyclesList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default ProductiveCycles;
